
'use strict'

class TextString {

    constructor(str) {
        this.value = new String(str);
    }
    
    cut (length) {
        if(this.value.length <= length){
            return this.value;
        }
        let arr = this.value.split(' ');
        let val = '';
        for(let i = 0; i < arr.length; i++){
            if(val.length + arr[i].length + 3 > length){
                val += '...';
                break;
            }
            val += ' ' + arr[i];
        }
        return val.trim();
    }

}

export default TextString;
